export default __webpack_public_path__ + "static/media/icon-zone.45a203d8.svg";